<template>
    <div id="hubble">
        <Spin size="large" fix></Spin>
    </div>
</template>
<script>
    /**
     * 控制导航分条件显示，进入到这个页面 代表就要触发这个逻辑
     */
    export default {
        created () {
            console.log('route:%O', this.$route)
        }
    }
</script>
<style>
    #hubble {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #f6c89f;
        z-index: 999;
    }
</style>



// WEBPACK FOOTER //
// src/views/hubble.vue